import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Script, ScriptStrategy } from 'gatsby';
import React from 'react';

import { Layout } from './src/components/Layout';
import {
  IS_PREVIEW,
  IS_PRO,
  IS_PRODUCTION,
  REGION,
  RegionEnum,
} from './src/constants';
import { StoreProvider } from './src/context/cart-context';

const queryClient = new QueryClient();

export const wrapRootElement = ({ element }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <StoreProvider>{element}</StoreProvider>
    </QueryClientProvider>
  );
};

export const wrapPageElement = ({ element, props }) => {
  const path = props.path || '';
  if (path.includes('/ugc')) {
    return element;
  }

  return (
    <>
      <Layout {...props}>{element}</Layout>

      {IS_PRODUCTION && !IS_PREVIEW ? (
        <>
          <Script
            id="google-tag-manager-consent-mode"
            strategy={ScriptStrategy.idle}
            dangerouslySetInnerHTML={{
              __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag() {
                dataLayer.push(arguments);
              }
              gtag("consent", "default", {
                ad_storage: "denied",
                analytics_storage: "denied",
                functionality_storage: "denied",
                personalization_storage: "denied",
                security_storage: "granted",
                wait_for_update: 2000,
              });
              gtag("set", "ads_data_redaction", true);`,
            }}
          />

          <Script
            id="google-tag-manager"
            strategy={ScriptStrategy.idle}
            dangerouslySetInnerHTML={{
              __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;
                
                j.addEventListener('load', function() {
                  var _ge = new CustomEvent('gtm_loaded', { bubbles: true });
                  d.dispatchEvent(_ge);
                });
                
                f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-TB93JXXQ');`,
            }}
          />

          <Script
            id="cookieyes"
            strategy={ScriptStrategy.idle}
            src={`https://cdn-cookieyes.com/client_data/${
              IS_PRO ? '3d64447ce8911503eab1be4e' : '07004a4cc30348d8c12d261b'
            }/script.js`}
          />

          <Script
            id="intercom"
            strategy={ScriptStrategy.idle}
            dangerouslySetInnerHTML={{
              __html: `
              window.intercomSettings = {
                api_base: "https://api-iam.intercom.io",
                app_id: "d6fkwz6r",
                action_color: "#2d0fe7",
                background_color: "#2d0fe7"
              };
              (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/znpit64y';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();  `,
            }}
          />
        </>
      ) : null}

      {REGION === RegionEnum.Us && !IS_PRO ? (
        <Script
          id="affirm"
          strategy={ScriptStrategy.idle}
          dangerouslySetInnerHTML={{
            __html: `
            window._affirm_config = {
              public_api_key: "Q9XLYO9RQ3VSA6XM",
              script: "${
                IS_PRODUCTION
                  ? 'https://cdn1.affirm.com/js/v2/affirm.js'
                  : 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js'
              }"
            };
            (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");`,
          }}
        />
      ) : null}

      <Script
        id="cylindo"
        src="https://viewer-cdn.cylindo.com/v1/index.mjs"
        type="module"
      />
      <Script
        id="cylindo-thumbnail"
        src="https://viewer-cdn.cylindo.com/v1/bar.mjs"
        type="module"
      />
    </>
  );
};
